/** Strings owned by `src/features/documents/` — PLAN-FASE3.md WP-03's
 * `/documents` upload modal + library, under the Content pill. */
export const documents = {
  page: {
    title: 'Documents',
    lead: 'Upload and manage documents for {{company}}.',
    noScope: 'Select a company to see its documents.',
    forbidden: 'You are not allowed to see this company’s documents.',
  },
  upload: {
    title: 'Upload document',
    titleField: 'Title',
    category: 'Category',
    audience: 'Target audience',
    fileUrl: 'File URL',
    file: 'File',
    upload_status: {
      uploading: 'Uploading…',
      tooLarge: 'File is too large (max 10MB).',
      invalidType: 'File type not allowed.',
    },
    fileUrlHint: 'Uploaded right away; or fill in an existing URL below.',
    requiresReadConfirmation: 'Require read confirmation',
    requiresReadConfirmationHint: 'Members must confirm they have read this document.',
    submit: 'Upload',
  },
  categories: {
    algemeen: 'General',
    beleid: 'Policy',
    veiligheid: 'Safety',
    hr: 'HR',
    vitaliteit: 'Vitality',
  },
  audiences: {
    iedereen: 'Everyone',
    management: 'Management',
    per_afdeling: 'Per department',
    per_locatie: 'Per location',
  },
  status: {
    gepubliceerd: 'Published',
    archief: 'Archived',
  },
  library: {
    title: 'Document library',
    empty: 'No documents yet.',
    totalViews: 'Total views: {{count}}',
    columns: {
      title: 'Title',
      category: 'Category',
      views: 'Views',
      status: 'Status',
    },
  },
  actions: {
    new: 'Upload document',
    cancel: 'Cancel',
    publish: 'Publish',
    archive: 'Archive',
  },
} as const;
